<template>
  <div v-if="value.length > 0" class="pwd-requirements">
    <div v-if="showLength" :class="['req-row', lengthMet ? 'req-met' : 'req-pending']">
      <b-icon :icon="lengthMet ? 'check-circle-fill' : 'exclamation-circle-fill'" class="req-icon" />
      <span>
        At least {{ effectiveMinLength }} characters
        <span class="req-count">({{ value.length }}/{{ effectiveMinLength }})</span>
      </span>
    </div>
    <div v-for="(charset, i) in displayedCharsets" :key="i" :class="['req-row', charset.test(value) ? 'req-met' : 'req-pending']">
      <b-icon :icon="charset.test(value) ? 'check-circle-fill' : 'exclamation-circle-fill'" class="req-icon" />
      <span>Include {{ charset.description.toLowerCase() }}</span>
    </div>
    <div v-if="showNote" class="req-note">{{ strengthCount }} of {{ effectiveMinCharsets }} required character types {{ noteLabel }}</div>
    <div v-if="isStrong" class="req-row req-met mt-1">
      <b-icon icon="check-circle-fill" class="req-icon" />
      <span>Password meets all requirements</span>
    </div>
  </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import passwordMixin from '@/mixins/password_mixin';

@Component({ mixins: [passwordMixin] })
export default class PasswordRequirements extends Vue {
  @Prop({ type: String, default: '' }) value;
  @Prop({ type: Boolean, default: false }) compact;
  @Prop({ type: String, default: 'needed' }) noteLabel;

  get password() {
    return this.value;
  }

  get effectiveMinLength() {
    return this.passwordRules.minLength || 8;
  }

  get effectiveMinCharsets() {
    return this.passwordRules.minCharsets || 3;
  }

  get lengthMet() {
    return this.value.length >= this.effectiveMinLength;
  }

  get strengthCount() {
    return this.passwordCharsets.reduce((sum, cs) => sum + (cs.test(this.value) ? 1 : 0), 0);
  }

  get isStrong() {
    return this.lengthMet && this.strengthCount >= this.effectiveMinCharsets;
  }

  get showLength() {
    return !this.compact || !this.lengthMet;
  }

  get showNote() {
    return !this.compact || this.strengthCount < this.effectiveMinCharsets;
  }

  get displayedCharsets() {
    return this.compact ? this.passwordCharsets.filter(cs => !cs.test(this.value)) : this.passwordCharsets;
  }
}
</script>
<style scoped>
.pwd-requirements {
  font-size: 0.8rem;
  padding: 0.5rem 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #e5e7eb;
}
.req-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.18rem 0;
}
.req-icon {
  flex-shrink: 0;
  font-size: 0.85em;
}
.req-pending {
  color: #92400e;
}
.req-pending .req-icon {
  color: #d97706;
}
.req-met {
  color: #065f46;
}
.req-met .req-icon {
  color: #059669;
}
.req-count {
  font-weight: 600;
  opacity: 0.8;
}
.req-note {
  font-size: 0.75rem;
  color: #6b7280;
  padding-left: 1.3rem;
  margin-top: 0.05rem;
}
</style>
